@use "variables" as *;

.container {
  position: relative;
  display: flex;
  width: 100%;
  align-items: flex-start;
  flex-direction: row;
  flex-shrink: 0;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    bottom: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  width: 30px !important;
  height: 30px !important;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonRadius {
  border-radius: 30px !important;
  min-width: 0 !important;
  min-height: 0 !important;
}

.reservedBox {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: 0.3;
  .reservedText {
    text-align: center;
    font-size: $fontSize-xl;
    font-weight: bolder;
    text-transform: uppercase;
  }
}

.upcomingBox {
  position: absolute;
  width: 100%;
  height: 12px;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  overflow: hidden;
  .backgroundCircle {
    position: absolute;
    border-radius: 150px;
    bottom: 0;
    left: 0;
    height: 300px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .upcomingText {
    text-align: center;
    font-size: $fontSize-xxxs;
    font-weight: bold;
    text-transform: uppercase;
  }
}

.upcomingPerimeter {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-style: solid;
  border-width: 2px;
  border-radius: 10px;
  pointer-events: none;
}

.highlightTag {
  position: absolute;
  display: flex;
  top: $spacing-xs;
  left: $spacing-xs;
  pointer-events: none;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  .highlightText {
    padding: $spacing-xs;
    font-size: $fontSize-xxs;
    font-weight: bold;
  }
}

.albumImage {
  display: flex;
  width: 64px;
  height: 64px;
}

.rightContainer {
  display: flex;
  align-self: stretch;
}

.name {
  font-size: $fontSize-ml;
  font-weight: 700;
  padding-left: $spacing-s;
}

.subtitle {
  font-size: $fontSize-xs;
  font-weight: normal;
  padding-left: $spacing-s;
  white-space: pre-wrap;
}

.orderWarning {
  font-size: $fontSize-xs;
  font-weight: bold;
  padding-left: $spacing-s;
}

.gradeText {
  font-size: $fontSize-xs;
  font-weight: normal;
}

.oldPrice {
  text-align: right;
  font-size: $fontSize-xxs;
  text-decoration-line: line-through;
  font-weight: lighter;
  overflow: hidden;
  white-space: nowrap;
}

.newPrice {
  font-size: $fontSize-s;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
}

.priceStack {
}
